import { Lightning as lng } from '@lightningjs/sdk';

export class TextIconsRow extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      h: 48,
      Text: {
        text: {
          text: '',
        },
      },
      Icons: {},
    };
  }

  _init() {
    this._iconSize = 40;
    this._iconSpacing = 8;
    this._icons = [];
    if (this.iconsFloatLeft === undefined) {
      this.iconsFloatLeft = true;
    }

    this.tag('Text').on('txLoaded', () => {
      this.positionIcons();
    });
  }

  positionIcons() {
    // this.h = Math.max(this.tag('Text').finalH, this._iconSize);
    const textWidth = this.tag('Text').finalW;
    if (this.iconsFloatLeft) {
      this.tag('Icons').x = textWidth ? textWidth + this._iconSpacing : 0;
    }
  }

  update() {
    let nrIcons = this._icons?.length || 0;
    let iconSectionWidth = nrIcons * this._iconSize;
    if (nrIcons > 1) iconSectionWidth += this._iconSpacing * nrIcons - 1;
    this._textWidth = this.w - iconSectionWidth;
    this.tag('Text').text.wordWrapWidth = this._textWidth;

    this.tag('Icons').childList.clear();
    let iconPos = 0;

    this._icons?.forEach(icon => {
      const iconElement = this.tag('Icons').childList.a({
        src: icon.src,
        w: this._iconSize,
        h: this._iconSize,
        x: iconPos,
        ...(icon.color ? { color: icon.color } : {}),
      });
      iconPos += this._iconSize + this._iconSpacing;
      iconElement.on('txLoaded', () => {
        this.positionIcons();
      });
    });

    if (!this.iconsFloatLeft) {
      // float right
      this.tag('Icons').x = this.w - iconSectionWidth;
    }
    // this.h = Math.max(this.tag('Text').finalH, this._iconSize);
  }

  /**
   * Object similar to the lightning text object {text: '', font: ..., fontSize: ...}
   * values of textOverflow, wordWrap and wordWrapWidth will be ignored in input
   * @param val
   */
  set textData(val) {
    this.tag('Text').text = {
      // ...this.tag('Text').text,
      ...val,
      textOverflow: '...',
      wordWrap: false,
      wordWrapWidth: this._textWidth,
    };
  }

  /**
   * @param {IconDef[]} iconList
   */
  set icons(iconList) {
    this._icons = iconList;
    this.update();
  }

  set iconSpacing(val) {
    this._iconSpacing = val;
    this.update();
  }

  set iconSize(val) {
    this._iconSize = val;
    this.update();
  }
}
